<script>
  export let currrentStep = 1;
  let step1var1;
  let step1error;
  let refreshing = false;

  const step1 = async () => {
    refreshing = true;
    if (step1var1 == undefined || step1var1.length < 6) {
        step1error = true;
        refreshing = false;
    } else {
      getData();
    }
  };

  const apiURL = '/password/reset/whodis/q/';

  const getData = async () => {
      const res = await fetch(apiURL + step1var1);

      if (!res.ok || res.status == '404') {
        step1error = true;
        step1var1 =''
        document.querySelector("#ahwhodis").focus();
      } else {
        //const data = await res.json();
        currrentStep = 2;
      };
      refreshing = false;
      // return data;
  }

</script>

<div class="card-body">
  <div class="alert alert-danger" class:hide={!step1error}>
    Please check your Username/ID number, it doesnt match our files
  </div>
  <form class="row g-3">
    <div class="col-auto">
      <label for="ahwhodis" class="col-form-label">Username</label>
    </div>
    <div class="col-auto">
      <input
        type="text"
        class="form-control"
        id="ahwhodis"
        autocomplete="off"
        autofocus
        bind:value={step1var1}
      />
    </div>
    <div class="col-auto">
      <button
        on:click|preventDefault={step1}
        type="submit"
        class="btn btn-outline-secondary mb-3"
      >
        {#if refreshing}
          <span><i class="fas fa-spinner fa-spin" /></span>
        {:else}
          <span>OK</span>
        {/if}
      </button>
    </div>
  </form>
</div>

<style>
</style>
